<script lang="ts">
	import Img from '#lib/html/Img.svelte';
	import VideoImage from '#lib/html/VideoImage.svelte';
	import { isDarkMode } from '#lib/stores/dark-mode.js';
	import type { WidgetTheme } from '#lib/types/generated/index.js';
	import WidgetTitle from '#lib/widget/components/WidgetTitle.svelte';
	import { classesDependingOnProfile } from '#lib/widget/theme.js';
	import { resetWidget } from '#lib/widget/booking/flow.js';
	import { widgetConfig, widgetContent, widgetShowHeaderContactInfo } from '#lib/widget/core.js';
	import { fade } from 'svelte/transition';

	interface Props {
		preview?: boolean;
	}
	let { preview = false }: Props = $props();

	function getTitleClasses(theme: WidgetTheme, _isDarkMode: boolean) {
		return classesDependingOnProfile(
			theme.inversedHeaderTextColor ? 'invert' : '',
			theme.dark.inversedHeaderTextColor ? 'dark:invert' : ''
		);
	}

	let businessInfo = $derived($widgetContent.business);

	let hasHeader = $derived(
		$widgetConfig.theme.showLogo ||
			$widgetConfig.theme.showBusinessName ||
			$widgetConfig.theme.banner
	);
	let style = $derived(
		$widgetConfig.theme.banner
			? `background-image: url(${$widgetConfig.theme.banner}); background-size: cover;`
			: ''
	);
	let backgroundClasses = $derived($widgetConfig.theme.banner ? 'bg-cover bg-center' : '');
	let titleClasses = $derived(getTitleClasses($widgetConfig.theme, $isDarkMode));
</script>

{#if hasHeader && businessInfo}
	<div
		class="flex sm:flex-row flex-col items-center {$widgetShowHeaderContactInfo
			? 'justify-around'
			: 'justify-center'} w-full flex-none
			{backgroundClasses} md:rounded-t-3xl overflow-hidden
			"
		{style}
	>
		<button
			class="items-center flex flex-col gap-5 p-5 min-h-32 flex-none justify-center w-full {preview
				? 'cursor-default'
				: ''}"
			transition:fade={{ duration: 300 }}
			onclick={() => {
				if (!preview) resetWidget();
			}}
		>
			{#if $widgetConfig.theme.showLogo}
				{@const logoUrl = businessInfo.logo ? businessInfo.logo : '/logo.svg'}
				<VideoImage
					src={logoUrl}
					alt={businessInfo.name}
					className="lg:h-32 h-24 max-w-full w-96 object-contain rounded-md"
				/>
			{/if}
			{#if $widgetConfig.theme.showBusinessName && !$widgetShowHeaderContactInfo}
				<WidgetTitle level="1" className="font-semibold {titleClasses}">
					{$widgetConfig.businessName || businessInfo.name}
				</WidgetTitle>
			{/if}
		</button>
		{#if $widgetShowHeaderContactInfo}
			<div
				class="text-sm text-left bg-widget-background dark:bg-widget-background-dark text-widget-background-on dark:text-widget-background-dark-on p-2 rounded-lg shadow-md m-2"
			>
				<div>
					<div class="font-semibold text-lg">
						{$widgetConfig.businessName || businessInfo.name}
					</div>
					{#if $widgetContent.business.defaultAddress}
						<a
							href="https://www.google.com/maps?q={$widgetContent.business
								.defaultAddress}"
							target="_blank"
							class="block"
						>
							<Img
								iconSizeClasses="w-4 h-4"
								icon="pin"
								displayTitle
								className="text-wrap"
								title={$widgetContent.business.defaultAddress}
							/>
						</a>
					{/if}
					{#if $widgetContent.business.defaultEmail}
						<a href="mailto:{$widgetContent.business.defaultEmail}">
							<Img
								iconSizeClasses="w-4 h-4"
								icon="email"
								displayTitle
								title={$widgetContent.business.defaultEmail}
								className=""
							/>
						</a>
					{/if}
					{#if $widgetContent.business.defaultPhone}
						<a href="tel:{$widgetContent.business.defaultPhone}">
							<Img
								iconSizeClasses="w-4 h-4"
								icon="mobile"
								displayTitle
								title={$widgetContent.business.defaultPhone}
								className=""
							/>
						</a>
					{/if}
				</div>
			</div>
		{/if}
	</div>
{/if}
